import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { clearDrillParams, parseDrillFilter, writeDrillFilter } from "../components/Status/statusFormat";
import type { DrillFilter } from "../types/status";

export function useStatusTabs(availableTabs: string[]) {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get("tab");
  const activeTab = tabParam && availableTabs.includes(tabParam) ? tabParam : "overview";

  const drillFilter = useMemo(() => parseDrillFilter(searchParams), [searchParams]);

  function setActiveTab(id: string, keepDrill = false) {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set("tab", id);
      if (!keepDrill) clearDrillParams(params);
      return params;
    }, { replace: true });
  }

  function drillTo(filter: DrillFilter) {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set("tab", "incidents");
      writeDrillFilter(params, filter);
      return params;
    }, { replace: true });
  }

  function clearDrill() {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      clearDrillParams(params);
      return params;
    }, { replace: true });
  }

  return { activeTab, setActiveTab, drillFilter, drillTo, clearDrill };
}
